import { connect } from "react-redux";
import UserDetailsGrid from "./UserDetailsGrid";
import { AppDispatch } from "store/store";
import Loader from "components/common/controls/Loader";
import { loadUserRelatedDataAsync } from "store/slices/UserManagementSlice";
import { Component } from "react";

interface State {
  isUserDataLoaded: boolean;
}

interface Props {
  dispatch: AppDispatch;
}

export class ManageUsers extends Component<Props, State> {
  state: Readonly<State> = {
    isUserDataLoaded: false,
  };

  componentDidMount() {
    this.setState({ isUserDataLoaded: false });
    this.props.dispatch(loadUserRelatedDataAsync()).finally(() => {
      this.setState({ isUserDataLoaded: true });
    });
  }

  render() {
    return (
      <div>
        <div className="mb-6">
          Welcome to Users Home Page.
        </div>
        <UserDetailsGrid />
        <Loader isVisible={!this.state.isUserDataLoaded} />
      </div>
    );
  }
}

export default connect()(ManageUsers);
